/* eslint-disable no-param-reassign */
import { AnyAction } from 'redux';
import produce from 'immer';
import { ALERT_CLEAR, ALERT_ERROR, ALERT_SUCCESS, ALERT_SEVERITIES } from '../../../constants/alert.constants';
import AlertState from '../../../models/redux/state/alert.state';

const initialState: AlertState = {
  severity: undefined,
  message: '',
};

const alertReducer = produce((draft: AlertState, action: AnyAction) => {
  switch (action.type) {
    case ALERT_SUCCESS:
      draft.severity = ALERT_SEVERITIES.SUCCESS;
      draft.message = action.message;
      break;
    case ALERT_ERROR:
      draft.severity = ALERT_SEVERITIES.ERROR;
      draft.message = action.message;
      break;
    case ALERT_CLEAR:
      draft.severity = initialState.severity;
      draft.message = initialState.message;
      break;
    default:
  }
}, initialState);

export default alertReducer;
